import { useEffect, useState } from "react";
import Button from "../components/button";
import Checkbox from "../components/checkbox";
import InfoBoxes from "../components/infoBoxes";
import Loader from "../components/loader";
import MultipleChoice from "../components/multipleChoice";
import PopUp from "../components/popUp";
import { useAppContext } from "../context/appContext";
import { PurchaseInfoResponseDTO } from "../openapi-generated-client";
import { formatPrice } from "../utils/priceUtils";

interface BuyPiecePopUpProps {
    pieceId: number;
}

export default function BuyPiecePopUp(props: BuyPiecePopUpProps) {

    const {purchaseController, sessionId} = useAppContext();

    const [loading, setLoading] = useState(false);
    const [useBalance, setUseBalance] = useState<boolean | undefined>(undefined);
    const [agb, setAgb] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setError(null);
    }, [agb, useBalance]);

    const [data, setData] = useState<PurchaseInfoResponseDTO>();

    async function fetchData() {
        setData((await purchaseController.getPiecePurchaseInfo(sessionId, props.pieceId)).data);
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if(useBalance === undefined && data != undefined) {
            setUseBalance(data.balance >= data.price);
        }
    }, [data])

    if(data == undefined) return <PopUp className="big" title="Buy Piece"><Loader/></PopUp>

    const options = [
        data.price > data.balance ? "Use " + (data.balance - data.price) + " € of your current balance, pay the remaining " + (data.price-(data.balance-data.price)) + "€ via stripe." : "Use your current balance",
        "Pay the full price"
    ]

    async function buy() {
        if(!agb) {
            setError("You need to agree to the terms and conditions.");
            return;
        }
        setLoading(true);
        purchaseController.pushPurchaseCommit(sessionId, props.pieceId, {
            useBalance: useBalance,
        }).then((response) => {
            if(response.status == 202) {
                window.open("/pieces/" + props.pieceId + "/purchased", "_self");
                return;
            }
            if(response.status == 200) {
                window.open(response.data.stripeCheckout.sessionUrl, "_self");
            }
            setLoading(false);
        }).catch((e) => {
            setError("An error occurred while processing your purchase.");
            setLoading(false);
        });
        
    }

    return <PopUp className="big" title={"Buy Piece: " + data.title}>
        <h2>Price: {useBalance ? <><h2 className="crossed-out">{data.price} €</h2> {data.priceReduced} €</> : <>{data.price} €</>}</h2>
        {data.balance >= data.price ? <>
            <MultipleChoice active={[options[useBalance ? 0 : 1]]} options={options} allowMultiple={false} onChange={(selected) => {
                setUseBalance(selected.includes(options[0]));
            }}/>
            <InfoBoxes backgroundColor="var(--light-grey)" infos={[
                {
                    title: "Current Balance",
                    value: formatPrice(data.balance) + " €"
                },
                {
                    title: "New Balance",
                    value: formatPrice((useBalance ? (data.balance - data.priceReduced) : data.balance)) + " €"
                }
            ]}/>
        </> : <></>}
        <Checkbox className="marginTop" label={<>I confirm that I have read and agree to the <a onClick={() => {
            window.open("/terms", "_blank");
        }}>terms of use</a>.</>} value={agb} onClick={(v: boolean) => setAgb(v)}/>
        <p className="error">{error}</p>
        <Button loading={loading} onClick={buy}>Pay now</Button>
    </PopUp>
    
}